import { render, staticRenderFns } from "./simple-menu.vue?vue&type=template&id=63aa1581&scoped=true&"
import script from "./simple-menu.vue?vue&type=script&lang=js&"
export * from "./simple-menu.vue?vue&type=script&lang=js&"
import style0 from "./simple-menu.vue?vue&type=style&index=0&id=63aa1581&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa1581",
  null
  
)

export default component.exports